@if ((layout$ | async) !== 'split') {
    <!-- Loading bar -->
    <app-fuse-loading-bar></app-fuse-loading-bar>

    <!-- Wrapper -->
    <div class="flex w-full flex-auto flex-col">
        <!-- Content -->
        <div class="flex flex-auto flex-col">
            @if (true) {
                <router-outlet></router-outlet>
            }
        </div>
    </div>
} @else {
    <div class="background-split-layout h-full w-full">
        <!-- Loading bar -->
        <app-fuse-loading-bar></app-fuse-loading-bar>

        <!-- Wrapper -->
        <div class="flex h-full w-full flex-auto flex-row gap-2 p-2">
            <!-- Content -->
            <div
                class="flex w-1/2 flex-auto flex-col overflow-hidden rounded-3xl">
                @if (true) {
                    <router-outlet></router-outlet>
                }
            </div>

            <div class="w-1/2 rounded-3xl">
                <ng-template #decorationComponent></ng-template>
            </div>
        </div>
    </div>
}
